module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a1cf2da558bd031749a8ea8d0d3a3e25.png";